import { useState } from 'react';

import { Box, FormControlLabel, Paper, Switch } from '@mui/material';

import ExportChartButton from '@/components/Chart/ExportButton/ExportChartButton';
import FullScreenChart from '@/components/Chart/FullScreenChart';
import { PageInformationContext } from '@/context/PageInformationContext';
import useUserDetails from '@/hooks/useUserDetails';
import useDhChart from '@/pages/DataHub/Chart/useDhChart';

const pageInformation = {
  mainPageTitle: 'Data Hub'
};
const DataHubChart = () => {
  const { isUserExpired, isUserBasic } = useUserDetails();
  const [isLightMode, setIsLightMode] = useState<boolean>(false);
  const { chartSeries, error, loading } = useDhChart();

  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: 1
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          paddingRight: 2,
          backgroundColor: 'background.paper',
          gap: 0.5
        }}
      >
        {!loading && !error && (
          <>
            <FormControlLabel
              control={
                <Switch
                  checked={!isLightMode}
                  onChange={() => {
                    setIsLightMode(!isLightMode);
                  }}
                />
              }
              label={isLightMode ? 'Light mode' : 'Dark mode'}
              labelPlacement='start'
              sx={{ fontWeight: 500 }}
            />
            <PageInformationContext.Provider value={pageInformation}>
              <ExportChartButton tabName='Chart' />
            </PageInformationContext.Provider>
          </>
        )}
      </Box>
      <Paper sx={{ p: 2, flexGrow: 1, display: 'flex', position: 'relative' }}>
        <Box sx={{ position: 'absolute ', width: 'calc(100% - 20px)', height: '100%' }}>
          <FullScreenChart
            isDataHub
            chartSeries={chartSeries}
            error={error}
            isLightMode={isLightMode}
            loading={loading && !(isUserExpired || isUserBasic)}
            tabName='Chart'
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default DataHubChart;
